import { useTranslation } from "react-i18next";
import Heading from "@components/layout/Heading";
import { useWaterClassContext } from "@context/WaterClassContext";
import EventTransactionPaginatedTable from "@components/table/EventTransactionPaginatedTable";
import EndButtonModal from "@components/shared/EndButton";

const WaterClassWorkflowCompleted = () => {
  const { t } = useTranslation();
  const { workflowInstance } = useWaterClassContext();

  return (
    <>
      <div className="flex flex-col gap-4 grow p-6">
        <Heading light>{t("level0wrs.create.workflow_complete")}</Heading>
        <EventTransactionPaginatedTable
          references={[workflowInstance?.id]}
          stickyHeader={true}
        />
      </div>
      <footer className="flex gap-4 p-6 border-t border-gray-200">
        <EndButtonModal />
      </footer>
    </>
  );
};

export default WaterClassWorkflowCompleted;
